import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/news.scss';

initMainHeader();
initNewsVideos();

/**
 * Lazy YouTube facade for the news article videos.
 * Each `.news-video[data-vsrc]` box shows only a poster + play button until the
 * user clicks/activates it, then the real iframe is injected and autoplayed.
 */
function initNewsVideos() {
    const allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    const boxes = document.querySelectorAll('.news-video[data-vsrc]');

    boxes.forEach((box) => {
        const play = () => loadVideo(box);

        box.addEventListener('click', play, {once: true});
        box.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                play();
            }
        });
    });

    function loadVideo(box) {
        const src = box.getAttribute('data-vsrc');

        if (!src) {
            return;
        }

        const iframe = document.createElement('iframe');

        iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.title = box.getAttribute('title') || 'YouTube video player';
        iframe.setAttribute('frameborder', '0');
        // Page sends `Referrer-Policy: no-referrer`; YouTube needs the embedding
        // origin to configure the player (otherwise: Error 153). Send origin only.
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        iframe.setAttribute('allow', allow);
        iframe.setAttribute('allowfullscreen', '');
        iframe.allowFullscreen = true;

        box.removeAttribute('data-vsrc');
        box.removeAttribute('role');
        box.removeAttribute('tabindex');
        box.innerHTML = '';
        box.appendChild(iframe);
    }
}

global.printDiv = function(divId) {
    const parentContainer = document.getElementById(divId);

    window.bLazy.load(parentContainer.querySelectorAll('img[data-src]'), true);

    setTimeout(() => {
        // Print from a clone so the live page is untouched. Video facades can't be
        // printed (no playback, and the poster is an ink-heavy color image), so drop
        // them here regardless of the cached print stylesheet — the caption + watch
        // link left behind carry the reference on paper.
        const printable = parentContainer.cloneNode(true);
        printable.querySelectorAll('.news-video').forEach((box) => box.remove());

        // Reuse the page stylesheet's version so the print CSS isn't served stale.
        const pageCss = document.querySelector('link[href*="-es6.css"]');
        const ver = pageCss && pageCss.href.indexOf('?') > -1
            ? pageCss.href.slice(pageCss.href.indexOf('?'))
            : '';

        const frame = window.frames["print_frame"];

        frame.document.body.innerHTML = [
            '<link href="build/assets/css/news.print.css' + ver + '" rel="stylesheet" type="text/css">',
            document.getElementById('newsTitle').outerHTML,
            printable.innerHTML
        ].join('');
        frame.window.focus();
        frame.window.print();
    }, 999)
}

